import { SettingsValueProps } from './components/settings/type';

// API
// ----------------------------------------------------------------------
export const HOST_API = process.env.REACT_APP_HOST_API_KEY || '';
export const BASE_PATH = '/bxwm2';

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
    MOBILE_HEIGHT: 64,
    MAIN_DESKTOP_HEIGHT: 88,
    DASHBOARD_DESKTOP_HEIGHT: 32,
    DASHBOARD_DESKTOP_OFFSET_HEIGHT: 32 - 32,
};

export const NAVBAR = {
    BASE_WIDTH: 260,
    DASHBOARD_WIDTH: 280,
    DASHBOARD_COLLAPSE_WIDTH: 88,
    //
    DASHBOARD_ITEM_ROOT_HEIGHT: 48,
    DASHBOARD_ITEM_SUB_HEIGHT: 40,
    DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
    NAVBAR_ITEM: 22,
    NAVBAR_ITEM_HORIZONTAL: 20,
};

export const defaultSettings: SettingsValueProps = {
    themeMode: 'light',
    themeDirection: 'ltr',
    themeColorPresets: 'blue',
    themeLayout: 'horizontal',
    themeStretch: true,
};

export const muiPremiumGridLicense = '9c08706bf81ae24bfda4f20fd1aa8e92Tz00NDg4MyxFPTE2ODU2OTE3NzkyMzksUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y';